import { createHeaders } from "@project-mgmt/api-client";
import { useTaskComments as useTaskCommentsAPI, useCreateTaskComment, useDeleteTaskComment } from "../api/tasks";
export function useTaskComments(taskId, workspaceId) {
    const { data: comments, error, isLoading, refetch } = useTaskCommentsAPI(taskId, workspaceId);
    const createCommentMutation = useCreateTaskComment(taskId, workspaceId);
    const deleteCommentMutation = useDeleteTaskComment(taskId, workspaceId);
    const addComment = async (content) => {
        try {
            const commentData = { content };
            const result = await createCommentMutation.trigger(commentData);
            // Refetch comments after adding new one
            await refetch();
            return { success: true, data: result };
        }
        catch (error) {
            return {
                success: false,
                error: error instanceof Error ? error.message : "Failed to add comment",
            };
        }
    };
    const updateComment = async (commentId, content) => {
        try {
            // Make direct API call for update
            const response = await fetch(`/api/tasks/${taskId}/comments/${commentId}?workspaceId=${workspaceId}`, {
                method: "PUT",
                headers: createHeaders(workspaceId),
                body: JSON.stringify({ content }),
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData?.error || "Failed to update comment");
            }
            const result = await response.json();
            // Refetch comments after updating
            await refetch();
            return { success: true, data: result };
        }
        catch (error) {
            return {
                success: false,
                error: error instanceof Error ? error.message : "Failed to update comment",
            };
        }
    };
    const deleteComment = async (commentId) => {
        try {
            const result = await deleteCommentMutation.trigger(commentId);
            // Refetch comments after deleting
            await refetch();
            return { success: true };
        }
        catch (error) {
            console.error("Delete comment error:", error);
            return {
                success: false,
                error: error instanceof Error ? error.message : "Failed to delete comment",
            };
        }
    };
    return {
        comments: comments || [],
        error,
        isLoading,
        addComment,
        updateComment,
        deleteComment,
        isAddingComment: createCommentMutation.isLoading,
        isDeletingComment: deleteCommentMutation.isLoading,
        refetch,
    };
}
